var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { FTLButton } from "../FTLButton";
import { FTLDraggableList } from "../FTLDraggableList";
import { FTLDropdownMenuWithController } from "./FTLDropdownMenuWithController";
export function FTLCheckboxSelector(_a) {
    var { buttonIcon, toolbar, DraggableListProps, children } = _a, otherProps = __rest(_a, ["buttonIcon", "toolbar", "DraggableListProps", "children"]);
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    return (React.createElement(FTLDropdownMenuWithController, Object.assign({ open: open, onClick: () => setOpen(true), onClickOutside: () => setOpen(false), controller: React.createElement(FTLButton, { color: "secondary", style: { width: 32 } }, buttonIcon) }, otherProps),
        children,
        React.createElement(FTLDraggableList, Object.assign({}, DraggableListProps, { className: classes.menuList, ComponentWrapperProps: {
                className: classes.option,
            } })),
        React.createElement("div", { className: classes.toolbar }, toolbar)));
}
const useStyles = makeStyles((theme) => ({
    menuList: {
        maxHeight: 222,
        overflow: "auto",
        marginBottom: 8,
    },
    option: {
        padding: "0px !important",
        "& > label": {
            padding: "4px 12px",
        },
    },
    toolbar: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "6px 15px",
        boxShadow: "inset 0px 1px 0px #EBEDF0",
    },
}));
//# sourceMappingURL=FTLCheckboxSelector.js.map